/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-14T10:58:26.418
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveFinancialEvidenceDetail,
	getFinancialEvidenceDetailCreateInit,
	getFinancialEvidenceDetailEditInit,
	getFinancialEvidenceDetailView,
	deleteFinancialEvidenceDetail
} from '@api/financial/FinancialEvidenceDetail';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getFinancialEvidenceDetailCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getFinancialEvidenceDetailCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialEvidenceDetailEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialEvidenceDetailEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveFinancialEvidenceDetail({}, FinancialEvidenceDetail) {
			return new Promise((resolve, reject) => {
				saveFinancialEvidenceDetail(FinancialEvidenceDetail)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialEvidenceDetailView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialEvidenceDetailView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialEvidenceDetail({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialEvidenceDetail({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
